import { useState } from "react";
import { api } from "./api/api";

export default function LoginScreen({ onLoggedIn }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setMsg("");

    try {
      setLoading(true);
     const data = await api.auth.login(username.trim(), password);

localStorage.setItem("token", data.token);
localStorage.setItem("user", JSON.stringify(data.user || null));
localStorage.setItem("permissions", JSON.stringify(data.permissions || []));


onLoggedIn?.(data);
    } catch (err) {
      setMsg(err.message || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="screen screen-center">
      <div className="card login-card">
        <h2 style={{ marginBottom: "0.75rem" }}>Login</h2>

        <form onSubmit={submit} className="login-form">
          <div className="field">
            <label>Username</label>
            <input value={username} onChange={(e) => setUsername(e.target.value)} />
          </div>

          <div className="field">
            <label>Password</label>
            <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} />
          </div>

          <button type="submit" disabled={loading}>
            {loading ? "Signing in..." : "Login"}
          </button>
        </form>

        {msg && <div className="message error" style={{ marginTop: "0.75rem" }}>{msg}</div>}
      </div>
    </div>
  );
}
